import React from 'react';
import { CalendarClock } from 'lucide-react';
import { Switch } from '../ui/switch';
import { useAutoWarmSettings, nextAutoRunLabel } from '../../hooks/useDemoWarmup';

const HOURS = Array.from({ length: 24 }, (_, h) => h);

// Tools launcher → under Prepare demo: schedule a daily automatic warm-up in this browser.
export default function AutoWarmupControl() {
  const [cfg, update] = useAutoWarmSettings();
  return (
    <div className="mx-4 mb-2 rounded-lg border border-slate-200 bg-slate-50/70 px-3 py-2" data-testid="auto-warmup-control">
      <div className="flex items-center justify-between gap-3">
        <label htmlFor="auto-warm-switch" className="flex items-center gap-2 text-xs font-semibold text-slate-800 cursor-pointer">
          <CalendarClock className="h-3.5 w-3.5 text-teal-600" /> Auto-prepare every morning
        </label>
        <Switch id="auto-warm-switch" checked={cfg.enabled} onCheckedChange={(v) => update({ enabled: v })} data-testid="auto-warmup-switch" />
      </div>
      <div className="mt-1.5 flex items-center justify-between gap-3 text-[11px] text-slate-500">
        <span className="flex items-center gap-1.5">
          at
          <select
            value={cfg.hour}
            onChange={(e) => update({ hour: Number(e.target.value) })}
            className="rounded border border-slate-200 bg-white px-1.5 py-0.5 text-[11px] text-slate-800"
            data-testid="auto-warmup-hour"
          >
            {HOURS.map((h) => <option key={h} value={h}>{String(h).padStart(2, '0')}:00</option>)}
          </select>
          local time
        </span>
        <span data-testid="auto-warmup-next">{cfg.enabled ? `Next: ${nextAutoRunLabel(cfg.hour)}` : 'Runs in this browser only'}</span>
      </div>
    </div>
  );
}
